export const Breakpoints = {
  md: 768,
  lg: 1025,
};
